import { Component, Input } from "@angular/core";
import { SocialAccount } from "app/js/src/domain/clipping-studio/publish/publish-models";

@Component({
  selector: "evrideo-clipping-studio-publish-preview-card",
  templateUrl: "./clipping-studio-publish-preview-card.component.html",
  styleUrls: ["./clipping-studio-publish-preview-card.component.scss"],
})
export class ClippingStudioPublishPreviewCardComponent {
  @Input() account!: SocialAccount;
  @Input() aspectRatio = "16:9";
  @Input() title = "Untitled";
  @Input() coverUrl: string | null = null;
  @Input() settingsLines: string[] = [];

  get coverAspectRatioCss(): string {
    const parts = (this.aspectRatio || "16:9").split(":");
    if (parts.length === 2) {
      const w = Number(parts[0]);
      const h = Number(parts[1]);
      if (w > 0 && h > 0) {
        return `${w} / ${h}`;
      }
    }
    return "16 / 9";
  }
}
